export interface PublicFaq {
  question: string;
  answer: string;
}

export const publicFaqs: PublicFaq[] = [
  {
    question: "What does FAB back up for Jotform?",
    answer:
      "FAB backs up Jotform form metadata and structure, including form settings, field definitions, properties, webhooks, and canonical backup data used for restore workflows.",
  },
  {
    question: "Does FAB back up Jotform submissions?",
    answer:
      "No. FAB is focused on form structure and configuration. It does not back up respondent submissions, uploaded files, or payment data collected through submitted entries.",
  },
  {
    question: "Can FAB restore a deleted or broken Jotform form?",
    answer:
      "FAB can restore a backed-up Jotform form by creating a new copy from stored backup data. It is designed for recovering form structure after accidental deletion, corruption, or unwanted edits.",
  },
  {
    question: "How often does FAB create backups?",
    answer:
      "FAB supports daily automated backups for connected Jotform accounts and also lets users create manual backups before or after large form changes.",
  },
  {
    question: "Who should use FAB?",
    answer:
      "FAB is built for teams and operators who rely on Jotform forms for critical workflows and need an independent backup safety net for form structure, configuration, and restore history.",
  },
  {
    question: "Is FAB affiliated with Jotform?",
    answer:
      "No. FAB is an independent third-party backup service and is not affiliated with, endorsed by, or sponsored by Jotform.",
  },
];
